export default __webpack_public_path__ + "static/media/hardCracker.66d1a822.png";